<template>
    <b-row>
        <b-col sm="12">
            <b-card body-class="py-2">
                <div class="crud-customers-contacts-heading">
                    <div class="crud-customers-contacts-heading__title">
                        <AppIcon name="people" class="mr-1" /> Contactos
                    </div>
                    <b-button @click="add()" type="button" variant="primary" size="sm" v-if="!isSeller">
                        <AppIcon name="add" class="mr-1" /> Agregar
                    </b-button>
                </div>
                <b-row class="mt-2">
                    <b-col>
                        <b-table class="mb-0 app-table app-table--compact"
                                responsive
                                :stacked="responsive ? isMobileViewport : true"
                                :hover="true"
                                :small="true"
                                :items="table.items"
                                :fields="table.fields"
                                v-if="table.items.length">

                            <template v-slot:cell(name)="data">
                                <small v-if="data.item.market_stall" class="crud-customers-contacts-table-market-stall">
                                    {{data.item.market_stall}}<br>
                                </small>
                                <div class="crud-customers-contacts-table-name">
                                    {{data.item.name}}
                                    <span v-if="data.item.observations" class="crud-customers-contacts-table-observations">
                                        <AppIcon name="info" v-b-tooltip.hover :title="data.item.observations" />
                                    </span>
                                </div>
                            </template>

                            <template v-slot:cell(contacts)="data">
                                <div v-if="data.item.email">
                                    <AppIcon name="mail" class="mr-1" />
                                    <b-link :href="'mailto:' + data.item.email">{{data.item.email}}</b-link>
                                </div>
                                <div v-if="data.item.phone">
                                    <AppIcon name="call" class="mr-1" />
                                    <b-link :href="'tel:' + data.item.phone">{{data.item.phone}}</b-link>
                                </div>
                            </template>

                            <template v-slot:cell(f_action)="data">
                                <b-dropdown right no-caret size="sm" variant="outline-secondary" boundary="window" v-if="!isSeller">
                                    <template #button-content>
                                        <AppIcon name="more_vert" label="Opciones" class="mr-1" /> Opciones
                                    </template>
                                    <b-dropdown-item @click="edit(data.item)">
                                        <AppIcon name="edit" /> Editar
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="remove(data.item)">
                                        <AppIcon name="delete" class="text-danger" /> Eliminar
                                    </b-dropdown-item>
                                </b-dropdown>
                            </template>
                        </b-table>
                        <EmptyState v-else icon="people" title="Sin contactos cargados" />
                    </b-col>
                </b-row>
            </b-card>

            <!-- ########################### -->
            <!-- #####     MODALES     ##### -->
            <!-- ########################### -->

            <!-- CRUD MAIN -->
            <b-modal v-model="modal.form.active"
                    :key="modal.form._id"
                    :id="modal.form._id">
                <div slot="modal-header" minimize class="app-modal-header">
                    <span class="app-modal-header__icon"><AppIcon name="people" /></span>
                    <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
                </div>

                <b-row>
                    <b-col md="12">
                        <b-form-group label="Nombre">
                            <b-form-input type="text"
                                            size="sm"
                                            v-model="crud.form.name"
                                            required
                                            placeholder="Ingresar un nombre">
                            </b-form-input>
                        </b-form-group>
                    </b-col>         

                    <b-col md="12">
                        <b-form-group label="Email">
                            <b-form-input type="text"
                                            size="sm"
                                            v-model="crud.form.email"
                                            required
                                            placeholder="Ingresar un email">
                            </b-form-input>
                        </b-form-group>            
                    </b-col>

                    <b-col md="12">
                        <b-form-group label="Teléfono" description="Ej: 5493416908870 (13 dígitos)">
                            <b-form-input type="text"
                                            size="sm"
                                            v-model="crud.form.phone"
                                            required
                                            placeholder="Ingresar un teléfono">
                            </b-form-input>
                        </b-form-group>            
                    </b-col>

                    <b-col md="12">
                        <b-form-group label="Puesto">
                            <b-form-input type="text"
                                            size="sm"
                                            v-model="crud.form.market_stall"
                                            required
                                            placeholder="Ingresar un puesto">
                            </b-form-input>
                        </b-form-group>            
                    </b-col>

                    <b-col md="12">
                        <b-form-group label="Observaciones">                            
                            <app-textarea                
                                v-model="crud.form.observations"
                                placeholder="Ingresar las observaciones..."
                                rows="3"
                                max-rows="6"
                            ></app-textarea>                            
                        </b-form-group>            
                    </b-col>                                        

                </b-row>

                <div slot="modal-footer">
                    <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
                    <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
                </div>
            </b-modal>            
        </b-col>    
    </b-row>
</template>
<script>
    import serviceAPI from './../services'
    import Error from '@/handler/error'
    import Session from '@/handler/session'
    import Profiles from '@/config/profiles'
    import Modules from '@/config/modules'
    import Helper from '@/handler/helper'
    import Funciones from '@/handler/funciones'

    export default {
        props: [
            'customers',
            'customersID',
            'responsive',
        ],
        data() {
            return {
                crud: {
                    form: {
                        id: 0,
                        customer_id: 0,
                        name: '',
                        phone: '',
                        email: '',
                        market_stall: '',
                        observations: '',
                    }
                },
                table : {
                    items: [],
                    fields: [
                        {key: 'name', label: 'Nombre', class: 'align-middle text-left', width:"100px"},
                        {key: 'contacts', label: 'Contacto', class: 'align-middle text-left', width:"240px"},
                        {key: 'f_action', label: 'Acciones', class: 'align-middle text-left', width:"30px"},
                    ],
                },
                modal: {
                    form: {
                        active: false,
                        title: ''
                    },
                },
                isMobileViewport: false,
                mobileMql: null,
                
            }
        },       
        watch: {       
            customersID: function (newQuestion, oldQuestion) {
                this.load()
            }
        },         
        mounted(){
            if(this.responsive) {
                this.mobileMql = window.matchMedia('(max-width: 767.98px)')
                this.isMobileViewport = this.mobileMql.matches
                this.mobileMql.addEventListener('change', this.updateMobileViewport)
            }
            if(this.customersID) {
                this.load()
            }            
        },
        beforeDestroy() {
            if(this.mobileMql) this.mobileMql.removeEventListener('change', this.updateMobileViewport)
        },
        computed: {
          isSeller() {
            var seller = Helper.getSeller()
            if(seller) {
              return true
            } else {
              return false
            }
          },  
        },
        methods: {
            updateMobileViewport(e) {
                this.isMobileViewport = e.matches
            },
            confirmDialog(message, options) {
                var danger = !!options.danger
                var icon = options.icon || (danger ? 'warning' : 'help')
                var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
                    this.$createElement('AppIcon', { props: { name: icon } }),
                    options.title
                ])
                return this.$bvModal.msgBoxConfirm(message, {
                    title: title,
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: danger ? 'danger' : 'dark',
                    okTitle: options.okTitle,
                    cancelTitle: options.cancelTitle || 'Cancelar',
                    footerClass: 'p-2',
                    headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
                    hideHeaderClose: false,
                    centered: true
                })
            },
            load() {
                let loader = this.$loading.show();

                var result = serviceAPI.obtenerContacts(this.customersID)
                    result.then((response) => {
                    var data = response.data
                    this.table.items = data
                                    
                    loader.hide()         
                })
                .catch(error => {
                    loader.hide()
                    this.$awn.alert(Error.showError(error))
                });   
            },
            add() {
                this.crud.form.id = 0
                this.crud.form.customer_id = this.customersID
                this.crud.form.name = ''
                this.crud.form.phone = ''
                this.crud.form.email = ''
                this.crud.form.market_stall = ''
                this.crud.form.observations = ''
                
                this.modal.form._id = Math.random().toString(36).slice(2, 8)
                this.modal.form.title = "Nuevo Contacto"
                this.modal.form.active = true
            },
            edit(item) {
                this.crud.form.id = item.id
                this.crud.form.customer_id = item.customer_id
                this.crud.form.name = item.name
                this.crud.form.phone = item.phone
                this.crud.form.email = item.email
                this.crud.form.market_stall = item.market_stall
                this.crud.form.observations = item.observations

                this.modal.form._id = Math.random().toString(36).slice(2, 8)
                this.modal.form.title = "Editar Contacto"
                this.modal.form.active = true
            },            
            save() {
                // valida que tenga el formato correcto para emails
                if(this.crud.form.email) {
                    var expreg = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$")
                    if (!expreg.test(this.crud.form.email)) {          
                        this.$awn.alert("El email no posee un formato válido")          
                        return false
                    }       
                }

                // valida que tenga el formato para whatsapp
                if(this.crud.form.phone) {
                  if(!Funciones.validarTelefonoWhatsapp(this.crud.form.phone)) {
                        this.$awn.alert("El nro de télefono no posee un formato válido para Whatsapp")
                        return false
                    }
                }

                let loader = this.$loading.show();                
                
                if (this.crud.form.id) {
                    var result = serviceAPI.editarContacts(this.crud.form, this.customersID);
                } else {
                    var result = serviceAPI.agregarContacts(this.crud.form, this.customersID);
                }

                result.then((response) => {                    
                    this.modal.form.active = false
                    loader.hide()                                        
                    this.load()                                        
                    this.$awn.success("Datos guardados con éxito");
                })
                .catch(error => {
                    loader.hide()
                    this.modal.form.active = false
                    this.$awn.alert(Error.showError(error));
                })
            },
            remove(item) {
                this.crud.form.id = item.id
                this.crud.form.name = item.name        

                this.confirmDialog('¿Desea borrar el contacto ' + this.crud.form.name + '?', {
                    title: 'Borrar Contacto',
                    icon: 'delete',
                    danger: true,
                    okTitle: 'SI',
                    cancelTitle: 'NO'
                })
                .then(value => {
                    if (value) {
                        let loader = this.$loading.show();
                        var result = serviceAPI.eliminarContacts(this.crud.form.id, this.customersID);

                        result.then((response) => {      
                            this.modal.form.active = false        
                            loader.hide()                                                        
                            this.load()
                            this.$awn.success("Registro eliminado");
                        })
                        .catch(error => {
                            loader.hide()
                            this.modal.form.active = false
                            this.$awn.alert(Error.showError(error));
                        })
                    }
                })
                .catch(error => {
                    this.$awn.alert(Error.showError(error));
                })
            },            
        }
    }
</script>
<style>
    .crud-customers-contacts-heading {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
    }
    .crud-customers-contacts-heading__title {
        font-size: 15px;
        font-weight: 600;
        display: flex;
        align-items: center;
    }
    .crud-customers-contacts-table-market-stall {
        color: var(--app-color-text-muted);
    }
    .crud-customers-contacts-table-name {
        font-size: 14px;
        font-weight: 700;
    }
    .crud-customers-contacts-table-observations {
        cursor: pointer;
    }
</style>
